'use strict';

/*global app*/
/*global services*/
/*global BasicProcess*/

function MismatchProcessingProcess(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.init();
}

MismatchProcessingProcess.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'MismatchProcessingProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  onBeforeLeavePage: function onBeforeLeavePage() {
    var _this = this;

    if (_this.getItems().length) {
      var RIDs = [];
      _this.getItems().each(function () {
        var $item = $(this);

        RIDs.push($item.data('rid'));
      });

      $.getSync(app.path('mismatch_processing_unhold_items') + 'RID[]=' + RIDs.join('&RID[]='));
    }

    return _this;
  },

  editItem: function editItem($row) {
    var _this = this;

    $.when($row.remove()).then(function () {
      if (!_this.getItems().length) {
        _this.backForm();
      }
    });

    return _this;
  },

  processItem: function processItem($row) {
    var _this = this;

    var settings = $.extend({}, _this.settings.itemForm, {
      saveCallBack: function (result) {
        _this.editItem($row, result);
      }
    });

    var data = {
      RID: $row.data('rid')
    };

    services.get('item-mismatch-processing-form').open(settings, data);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
